import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import arTranslations from './locales/ar.json';

const resources = {
    en: {
        translation: enTranslations
    },
    fr: {
        translation: frTranslations
    },
    ar: {
        translation: arTranslations
    }
} as const;

const i18n = i18next
    .use(LanguageDetector)
    .use(initReactI18next);

void i18n.init({
    resources,
    fallbackLng: 'en',
    detection: {
        order: ['navigator']
    },
    interpolation: {
        escapeValue: false
    }
});

export default i18n; 